<template>
  <v-container>
    <v-layout row wrap justify-center class="mt-3">
      <v-flex xs12 class="text-xs-center">
        <h1>Trials By {{ enrollments }}</h1>
          <v-alert v-if="trials == false" color="info" icon="new_releases" :value="true">
            There are no trials for the {{ enrollments }} enrollment.
          </v-alert>
      </v-flex>
      <v-flex xs12 sm10 md8>
        <v-card class="info" v-for="item in trials" v-bind:key="item.trialId" >
          <v-list class="listItems pa-0">
              <v-list-tile class="pb-2 pt-2 pl-2">
                <v-list-tile-avatar>
                  <v-icon left>folder</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.trialName"></v-list-tile-title>
                  <!-- <v-list-tile-sub-title>{{ item.trialDate | date }}</v-list-tile-sub-title> -->
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn light flat ripple :to="'/trials/' + item.trialId">
                    <right-icon v-bind:color="item.active ? 'primary' : 'grey'" />
                  </v-btn>
                </v-list-tile-action>
                <v-menu bottom left v-if="userIsAuthenticated">
                  <v-btn icon slot="activator">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-btn dark flat class="red darken-3" @click="onDeleteTrial(item)">
                          <v-icon small dark class="text--lighten-1">delete</v-icon>
                        </v-btn>
                      </v-list-tile-action>                      
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center class="mt-0">
      <v-flex xs12 class="text-xs-center">
        <v-btn align-center depressed class="mt-0 cyan--text text--darken-3 text-center" color="cyan lighten-5" dark :to="'/trial/new'">New Trial</v-btn>        
      </v-flex>      
    </v-layout>    
  </v-container>
</template>
<script>
export default {
  props: ['enrollmentId'],
  data () {
    return {
    }
  },
  computed: {
    trials () {
      var loadedTrialss = this.$store.getters.loadedTrialsByEnrollment(this.enrollmentId)
      return loadedTrialss.sort((a, b) => {
        var EPa = this.$store.getters.loadedEnrollment(a.trialEnrollment)
        var EPb = this.$store.getters.loadedEnrollment(b.trialEnrollment)
        return (EPa.enrollmentPriority > EPb.enrollmentPriority) ? 1 : ((EPb.enrollmentPriority > EPa.enrollmentPriority) ? -1 : 0)
      })
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    enrollments () {
      console.log(this.enrollmentId)
      if (typeof this.$store.getters.loadedEnrollment(this.enrollmentId) !== 'undefined') {
        var locaName = this.$store.getters.loadedEnrollment(this.enrollmentId)
        return locaName.enrollmentName
      }
    }
  },
  methods: {
    onDeleteTrial (trial) {
      this.$store.dispatch('deleteTrialData', trial)
      this.$router.push('/trials')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Singular.vue?dbb03352